import { Plan } from '@accedo/one-plugin-sdk';
import { FC } from 'react';
import styled, { css } from 'styled-components';

import {
  cssPlanContainerBase,
  PlanPickerGrid,
  PlanPickerMainText,
  PlanPickerSubText,
} from '#/plugins/paywall/components';
import { translateDescription, translatePrice } from '#/plugins/paywall/utils';
import { remify } from '#/service/utils';

import { focusShadow } from '../common';

interface PlanProps extends Plan {
  isSelected: boolean;
  onSelect: (id: string) => void;
}

const FormPlan: FC<PlanProps> = ({
  id,
  title,
  description,
  price,
  currency,
  duration,
  nextPayment,
  isSelected,
  onSelect,
}) => {
  return (
    <PlanRoot
      aria-checked={isSelected}
      className={isSelected ? 'selected' : ''}
      onClick={() => onSelect(id)}
      role="radio"
      type="button"
    >
      <PlanPickerGrid>
        <PlanPickerMainText>{title}</PlanPickerMainText>
        <PlanPickerMainText>
          {translatePrice(price, currency, duration)}
        </PlanPickerMainText>
      </PlanPickerGrid>
      <PlanPickerSubText>
        {translateDescription(description, price, currency, nextPayment)}
      </PlanPickerSubText>
    </PlanRoot>
  );
};

FormPlan.displayName = 'FormPlan';

export default FormPlan;

const cssPlanSelected = css`
  background-image: linear-gradient(
    to bottom,
    var(--iapGradientTop),
    var(--iapGradientBottom)
  );
  color: var(--iapForeground);
`;

const PlanRoot = styled.button`
  ${cssPlanContainerBase};
  display: grid;
  row-gap: ${remify(8)};
  min-height: ${remify(108)};
  box-sizing: border-box;
  cursor: pointer;
  outline: none;
  border: none;
  text-align: initial;

  &.selected,
  &:hover {
    ${cssPlanSelected}
  }

  &.focus-visible {
    ${focusShadow}
  }
`;

const PlanCardInput = styled.input`
  display: none;

  &:checked + label > div {
    ${cssPlanSelected}
  }
`;

PlanCardInput.displayName = 'PlanCardInput';
